export var brandingRelativePath = function (locale, brandId) { return brandId ? "/helpcenter/".concat(locale, "/branding?brandId=").concat(brandId) : "/helpcenter/".concat(locale, "/branding"); };
export var hcCustomFontRelativePath = "/apps/helpcenter/custom-font";
export var createBrandingApi = function (baseUrl, http) {
    var apiUrl = function (locale, brandId) { return baseUrl + brandingRelativePath(locale, brandId); };
    return {
        get: function (dto) {
            return http.get(apiUrl(dto.locale, dto.brandId));
        },
        updateBranding: function (dto, locale) {
            return http.put("".concat(apiUrl(locale)), dto);
        },
        getCustomFontDataByUrl: function (dto) {
            return http.post("".concat(dto.tenantDefaultHost).concat(hcCustomFontRelativePath), { fontUrl: dto.fontUrl });
        }
    };
};
//# sourceMappingURL=index.js.map